var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Liste de dossiers")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":5},on:{"click:row":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }